<template>
  <div>
    <v-container class="py-10">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <h2>12. Digitalisierung als Herausforderung: "Deep Dive" 2</h2>
          <p>
            Hinweis: Hier muss auf jeden Fall eine Beschreibung rein, was klein
            bzw groß bedeutet!
          </p>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ChallengeDD2",
  computed: {
    chartOptions() {
      return {
        title: {
          text:
            "Wir groß sind die die Herausforderungen in Zusammenhang mit der Digitalisierung für Ihre Organisation?"
        },

        xAxis: {
          categories: ["Sehr klein", "", "", "", "", "", "", "", "Sehr groß"]
        },
        yAxis: {
          min: 3,
          max: 3.5,
          title: {
            text: "Einschätzung der Herausforderung"
          },
          categories: ["", "", "", "Mittel", "Groß", ""]
        },

        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            }
          }
        },

        series: [
          {
            name: "Digitalisierung als Herausforderung",
            data: [2.86, 3.0, 3.23, 3.47, 3.55, 3.6, 3.82, 3.8, 4.06]
          },
          {
            name:
              "Einhaltung von Gesetzgebungen (z.B. Datenschutzgrundverordnung)",
            data: [3.68, 3.67, 3.73, 3.81, 3.76, 4.0, 3.74, 3.83, 3.86]
          },
          {
            name:
              "Aufbringung der erforderlichen Ressourcen zur Investition in Digitalisierung (z.B. Mitarbeiterqualifizierung)",
            data: [3.32, 3.31, 3.48, 3.63, 3.62, 3.85, 3.79, 3.83, 3.94]
          }
        ],

        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom"
                }
              }
            }
          ]
        }
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
